module.exports = __webpack_public_path__ + "static/media/HUK.c2d69d39.svg";